











































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class PythonDataStructures extends Vue {
}
